/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AwardWalletAuthUrlRequest
 */
export interface AwardWalletAuthUrlRequest {
    /**
     * AwardWallet platform value for the connection flow.
     * @type {string}
     * @memberof AwardWalletAuthUrlRequest
     */
    platform: string;
    /**
     * AwardWallet access value for the connection flow.
     * @type {string}
     * @memberof AwardWalletAuthUrlRequest
     */
    access?: string;
    /**
     * Web or mobile destination to redirect to after callback.
     * @type {string}
     * @memberof AwardWalletAuthUrlRequest
     */
    returnUrl: string;
}

/**
 * Check if a given object implements the AwardWalletAuthUrlRequest interface.
 */
export function instanceOfAwardWalletAuthUrlRequest(value: object): value is AwardWalletAuthUrlRequest {
    if (!('platform' in value) || value['platform'] === undefined) return false;
    if (!('returnUrl' in value) || value['returnUrl'] === undefined) return false;
    return true;
}

export function AwardWalletAuthUrlRequestFromJSON(json: any): AwardWalletAuthUrlRequest {
    return AwardWalletAuthUrlRequestFromJSONTyped(json, false);
}

export function AwardWalletAuthUrlRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AwardWalletAuthUrlRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'platform': json['platform'],
        'access': json['access'] == null ? undefined : json['access'],
        'returnUrl': json['return_url'],
    };
}

export function AwardWalletAuthUrlRequestToJSON(json: any): AwardWalletAuthUrlRequest {
    return AwardWalletAuthUrlRequestToJSONTyped(json, false);
}

export function AwardWalletAuthUrlRequestToJSONTyped(value?: AwardWalletAuthUrlRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'platform': value['platform'],
        'access': value['access'],
        'return_url': value['returnUrl'],
    };
}

